<template>
    <div class="statistics-today">
        <div class="left-content">
            <div class="left-content-title">
                <a-icon style="color:#ccc" type="profile" />
                <span style="margin-left:4px;color:#aaa">项目列表选择</span>
            </div>
            <ul class="left-content-ul">
                <li :title="item.name" v-for="(item, index) in proList" :key="index" :class="{'active':currentProject.id==item.id}" @click="selectProject(item)">
                    {{item.name}}
                </li>
            </ul>
        </div>
        <div class="right-content">
            <div style="height:58px;line-height:58px;background:#fff;">
                <span style="float:left;font-size:18px;color:rgba(51, 51, 51, 1);font-weight:bold;margin-left:24px;">
                    <a-icon style="margin-right:5px" type="calendar" />
                    {{currentProject.name}}
                </span>
                <span style="float:right;color:rgba(153, 153, 153, 1);font-size:14px;margin-right:24px;">统计日期：{{rangeTime}}</span>
            </div>
            <div style="padding:24px 24px 48px 24px">
                <div class="right-content-title">
                    <div class="project-num" style="background:#fff;margin-right:16px;padding:12px 0px">
                        <div style="color:rgba(51, 51, 51, 1);font-size:16px;padding:0 24px;font-weight:bold">数据概况</div>
                        <a-divider style="background:rgba(240, 240, 240, 1);margin:12px 0" />
                        <a-row style="text-align:center">
                            <a-col :span="8">
                                <div style="color:rgba(34, 215, 187, 1);font-size:28px;font-weight:bold;margin:50px 0 8px 0">{{staticInfo.callCount}}</div>
                                <div style="color:rgba(153, 153, 153, 1);font-size:14px;">今日外呼量（次）</div>
                            </a-col>
                            <a-col :span="8">
                                <div style="color:rgba(34, 215, 187, 1);font-size:28px;font-weight:bold;margin:50px 0 8px 0">{{staticInfo.averageCallTime}}</div>
                                <div style="color:rgba(153, 153, 153, 1);font-size:14px;">今日平均通话时长（秒）</div>
                            </a-col>
                            <a-col :span="8">
                                <div style="color:rgba(34, 215, 187, 1);font-size:28px;font-weight:bold;margin:50px 0 8px 0">{{staticInfo.smsCount}}</div>
                                <div style="color:rgba(153, 153, 153, 1);font-size:14px;">发送短信数量（条）</div>
                            </a-col>
                        </a-row>
                    </div>
                    <div style="flex:1;background:#fff;padding:12px 0px">
                        <div class="title">
                            <span style="color:rgba(51, 51, 51, 1);font-size:16px;padding:0 24px;font-weight:bold">外呼量统计</span>
                        </div>
                        <a-divider style="background:rgba(240, 240, 240, 1);margin:12px 0" />
                        <div id="myChart2" :style="{width: '100%', height: '175px',padding:'0 24px;'}"></div>
                    </div>
                </div>
                <div class="right-content-chart" style="display:flex;padding:12px 0px">
                    <div class="chart-card" style="width:600px">
                        <div class="title">
                            <span style="color:rgba(51, 51, 51, 1);font-size:16px;padding:0 24px;font-weight:bold">各机器人外呼量统计</span>
                        </div>
                        <a-divider style="background:rgba(240, 240, 240, 1);margin:12px 0" />
                        <div style="display:flex;padding:0 24px;">
                            <div style="width:100px;display:inline-block;text-align:center">
                                <div style="padding-top:60px;padding-bottom:8px;font-size:28px;color:rgba(80, 80, 80, 1);font-weight:bold">{{staticInfo.robotCount}}</div>
                                <div style="color:rgba(153, 153, 153, 1);font-size:14px;">机器人总数</div>
                            </div>
                            <div style="width:100px;display:inline-block;text-align:center">
                                <div style="padding-top:60px;padding-bottom:8px;font-size:28px;color:rgba(80, 80, 80, 1);font-weight:bold">{{staticInfo.robotCount==0?0:(staticInfo.callCount/staticInfo.robotCount).toFixed(2)}}</div>
                                <div style="color:rgba(153, 153, 153, 1);font-size:14px;">日均话单</div>
                            </div>
                            <div id="myChart1" style="flex:1;height:180px;display:inline-block"></div>
                        </div>
                        
                    </div>
                    <div class="chart-card" style="flex:1;padding:12px 0">
                        <div class="title">
                            <span style="color:rgba(51, 51, 51, 1);font-size:16px;padding:0 24px;font-weight:bold">挂断点时长统计</span>
                        </div>
                        <a-divider style="background:rgba(240, 240, 240, 1);margin:12px 0" />
                        <div id="myChart3" :style="{width: '100%', height: '190px',padding:'0 24px;'}"></div>
                    </div>
                </div>
                <div class="right-content-content" style="padding:12px 0px">
                    <div class="title">
                        <span style="font-size:16px;color:rgba(51, 51, 51, 1);padding:0 24px;font-weight:bold">标签统计概况</span>
                    </div>
                    <a-divider style="background:rgba(240, 240, 240, 1);margin:12px 0" />
                    <div id="myChart4" :style="{width: '100%', height: '290px', padding:'0 24px;'}"></div>
                </div>
            </div>
          
        </div>
    </div>
</template>

<script>
export default {
    name: 'StatisticsToday',
    props: {
        msg: String
    },
    data() {
        return {
            proList: [],
            currentProject: {
                id: '',
                name: ''
            },
            rangeTime: '',
            dataTime: {
                startTime: '',
                endTime: ''
            },
            staticInfo: {},
        };
    },
    methods: {
        queryProList() {
            this.axios.get('/api/dropdown/project')
            .then(response=> {
                if(response.data.code == 0){
                    this.proList = response.data.data
                    if(response.data.data.length > 0){
                        this.currentProject = response.data.data[0]
                        this.queryGeneralStatistics()
                        this.querycallCountChannel()
                        this.querycallCountTime()
                        this.querycallCountDuration()
                        this.querycallCountLabel()
                    }
                }else{
                   this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        selectProject(item) {
            this.currentProject = item
            this.writeCurrentDate()
            this.queryGeneralStatistics()
            this.querycallCountTime()
            this.querycallCountLabel()
            this.querycallCountDuration()
            this.querycallCountChannel()
        },
        writeCurrentDate() {
            let now = new Date();
            let year = now.getFullYear(); //得到年份
            let month = now.getMonth();//得到月份
            let date = now.getDate();//得到日期
            let hour = now.getHours();//得到小时
            let minu = now.getMinutes();//得到分钟
            month = month + 1;
            if (month < 10) month = "0" + month;
            if (date < 10) date = "0" + date;
            if (hour < 10) hour = "0" + hour;
            if (minu < 10) minu = "0" + minu;
            this.rangeTime = year + "-" + month + "-" + date
            this.dataTime.startTime = year + "-" + month + "-" + date
            this.dataTime.endTime = year + "-" + month + "-" + date
        },
        drawLine1(data){
            let nameList = []
            let dataList = []
            for(let i = 0; i < data.length; i++){
                nameList.push(data[i]['channel'])
                let obj = {}
                obj.value = data[i]['callCount']
                obj.name = data[i]['channel']
                dataList.push(obj)
            }
            let myChart = this.$echarts.init(document.getElementById('myChart1'))
            myChart.setOption({
               tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    show: false,
                    orient: 'vertical',
                    right: 30,
                    data: nameList
                },
                series: [
                    {
                        name: '各机器人外呼量',
                        type: 'pie',
                        radius: ['50%', '70%'],
                        center: ['50%', '50%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center',
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '30',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: dataList,
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                        },
                    }
                ]
            });
        },
        drawLine2(data){
            let dataX = [], dataY = []
            for(let i = 0; i < data.length; i++){
                dataX.push(data[i]['time'])
                dataY.push(data[i]['callCount'])
            }
            let myChart = this.$echarts.init(document.getElementById('myChart2'))
            myChart.setOption({
                color: ['rgb(78, 138, 250)'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {        
                        type: 'shadow'      
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: dataX,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLine: {
                            lineStyle:{
                                color:'#E0E0E0',//x轴的颜色
                                width:1,//轴线的宽度  
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#939393'
                            }
                        },
                    }
                ],
                dataZoom: [{
                    type: 'inside'
                }],
                yAxis: [
                    {
                        type: 'value',
                        axisLine: {
                            lineStyle:{
                                color:'#E0E0E0',//x轴的颜色
                                width:0,//轴线的宽度  
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#939393'
                            }
                        },
                        splitLine:{  
                            show:true  ,
                            lineStyle:{
                                color:'#eee',
                                width: 1
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '外呼量统计',
                        type: 'bar',
                        barWidth: '60%',
                        data: dataY,
                        label: {
                            show: true,
                            position: 'top'
                        },
                    }
                ]
            });
        },
        drawLine3(data){
            let dataX = [], dataY = []
            let maxDataX = '120秒', maxDataY = 0 
            for(let i = 0; i < data.length; i++){
                if(Number(data[i]['duration'].split("秒")[0]) > 119){
                    maxDataY += data[i]['callCount']
                }else{
                    dataX.push(data[i]['duration'])
                    dataY.push(data[i]['callCount'])
                }
            }
            if(maxDataY != 0 ){
                dataX.push(maxDataX)
                dataY.push(maxDataY)
            }
            let myChart = this.$echarts.init(document.getElementById('myChart3'))
            myChart.setOption({
                xAxis: {
                    type: 'category',
                    data: dataX,
                    axisLine: {
                        lineStyle:{
                            color:'#E0E0E0',//x轴的颜色
                            width:1,//轴线的宽度  
                        }
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                        color: '#939393'
                        }
                    },
                },
                dataZoom: [{
                    type: 'inside'
                }],
                tooltip : {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle:{
                            color:'#E0E0E0',//x轴的颜色
                            width:0,//轴线的宽度  
                        }
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                        color: '#939393'
                        }
                    },
                    splitLine:{  
                        show:true  ,
                        lineStyle:{
                        color:'#eee',
                        width: 1
                        }
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '10%',
                    containLabel: true
                },
                series: [{
                    data: dataY,
                    type: 'line',
                    smooth: true,
                    symbol: 'circle',//折线点设置为实心点
                    symbolSize: 4,   //折线点的大小
                    itemStyle: {
                        normal: {
                            color: "#22d7bb",//折线点的颜色
                            lineStyle: {
                            color: "#22d7bb"//折线的颜色
                            }
                        }
                    }
                }]
            });
        },
        drawLine4(data){
            let dataX = [], dataY = []
            for(let i = 0; i < data.length; i++){
                dataX.push(data[i]['label'])
                dataY.push(data[i]['callCount'])
            }
            let myChart = this.$echarts.init(document.getElementById('myChart4'))
            myChart.setOption({
                color: ['#90EBDD'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {        
                        type: 'shadow'      
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: dataX,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLine: {
                            lineStyle:{
                                color:'#E0E0E0',//x轴的颜色
                                width:1,//轴线的宽度  
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#939393'
                            }
                        },
                    }
                ],
                dataZoom: [{
                    type: 'inside'
                }],
                yAxis: [
                    {
                        type: 'value',
                        axisLine: {
                            lineStyle:{
                                color:'#E0E0E0',//x轴的颜色
                                width:0,//轴线的宽度  
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#939393'
                            }
                        },
                        splitLine:{  
                            show:true  ,
                            lineStyle:{
                                color:'#eee',
                                width: 1
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '标签统计',
                        type: 'bar',
                        barWidth: '60%',
                        data: dataY,
                        label: {
                            show: true,
                            position: 'top'
                        },
                    }
                ]
            });
        },
        queryGeneralStatistics() {
            this.axios(
                {
                    method:'get',
                    url:'/api/statistic/project/total', 
                    params: {
                        projectId: this.currentProject.id,
                        startDate: this.dataTime.startTime,
                        endDate: this.dataTime.endTime
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.staticInfo = response.data.data
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        querycallCountTime() {
            this.axios(
                {
                    method:'get',
                    url:'/api/statistic/project/callCount/time', 
                    params: {
                        projectId: this.currentProject.id,
                        startDate: this.dataTime.startTime,
                        endDate: this.dataTime.endTime
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.drawLine2(response.data.data)
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        querycallCountLabel() {
            this.axios(
                {
                    method:'get',
                    url:'/api/statistic/project/callCount/label',
                    params: {
                        projectId: this.currentProject.id,
                        startDate: this.dataTime.startTime,
                        endDate: this.dataTime.endTime
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.drawLine4(response.data.data)
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        querycallCountDuration() {
            this.axios(
                {
                    method:'get',
                    url:'/api/statistic/project/callCount/duration', 
                    params: {
                        projectId: this.currentProject.id,
                        startDate: this.dataTime.startTime,
                        endDate: this.dataTime.endTime
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.drawLine3(response.data.data)
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        querycallCountChannel() {
            this.axios(
                {
                    method:'get',
                    url:'/api/statistic/project/callCount/channel', 
                    params: {
                        projectId: this.currentProject.id,
                        startDate: this.dataTime.startTime,
                        endDate: this.dataTime.endTime
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.drawLine1(response.data.data)
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
    },
    mounted: function() {
        this.sessionData('set','currentNavItem','StatisticsToday');
        this.queryProList()
        this.writeCurrentDate()
    }
}
</script>

<style scoped  lang="less">
    .statistics-today{
        background: #eee;
        display: flex;
        height: 100%;
        .left-content{
            width: 240px;
            background:#fff;
            height: 100%;
            overflow-y: auto;
            padding-bottom: 50px;
            .left-content-title{
                height: 60px;
                line-height: 60px;
                font-size: 18px;
                color: rgba(51, 51, 51, 1);
                padding-left: 24px;
                border-right: 1px solid #f0f2f3;
            }
            .left-content-ul{
                li{
                    height: 48px;
                    line-height: 48px;
                    width: 100%;
                    overflow: hidden;
                    cursor: pointer;
                    padding: 0 24px;
                    color: rgba(80, 80, 80, 1);
                }
                li:hover{
                    background: rgba(34, 215, 187, 0.1);
                    color: rgba(34, 215, 187, 1);
                }
                li.active{
                    color: rgba(34, 215, 187, 1);
                    background: rgba(34, 215, 187, 0.1);
                    border-right: 4px solid rgba(34, 215, 187, 1);
                }
            }
        }
        .right-content{
            flex: 1;
            padding: 0px 0px 24px 0px;
            height: 100%;
            overflow-y: auto;
            .right-content-title{
                height: 240px;
                width: 100%;
                display: flex;
                .project-name{
                    span:nth-child(1){
                        color: rgba(51, 51, 51, 1);
                        font-size: 18px;
                        margin-right:4px;
                    }
                    span:nth-child(2){
                        color: rgba(153, 153, 153, 1);
                        font-size: 14px;
                    }
                }
                .project-num{
                    
                    width:600px;
                    ul{
                        margin-top:0px;
                        li{
                            display: inline-block;
                            width:25%;
                            float: left;
                            text-align: center;
                            div:nth-child(1){
                                color: rgba(34, 215, 187, 1);
                                font-size: 36px;
                                margin:0 0 8px 0;
                            }
                            div:nth-child(2){
                               color: rgba(153, 153, 153, 1);
                               font-size: 14px; 
                            }
                        }
                    }
                }
            }
            .right-content-chart{
                height: 278px;
                margin: 15px 0;
                width: 100%;
                border-radius: 4px;
                display: flex;
                .chart-card{
                    height: 100%;
                    background: #fff;
                    padding: 12px 0;
                    .title{
                        span:nth-child(1){
                            color: rgba(51, 51, 51, 1);
                            font-size: 16px;
                            margin-right:4px;
                        }
                    }
                }
                div.chart-card:nth-child(2){
                    margin-left: 16px;
                }
            }
            .right-content-content{
                height: 375px;
                background: #fff;
                width: 100%;
                padding: 24px 0;
                .title{
                    span:nth-child(1){
                        color: rgba(51, 51, 51, 1);
                        font-size: 18px;
                        margin-right:4px;
                    }
                    span:nth-child(2){
                        color: rgba(153, 153, 153, 1);
                        font-size: 14px;
                    }
                }
            }
        }
    }

</style>
